let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUvh0")).then(() => parcelRequire('kUWUR'));